export var SHOW_TOOLTIP = 'showTooltip';
export var HIDE_TOOLTIP = 'hideTooltip';
export var CENTER_CHANGE = 'centerChange';
export var ZOOM_CHANGE = 'zoomChange';
export var INIT = 'init';
